export default "__VITE_ASSET__F3z2s8k6__"